import { render } from "./EnduserChatSettingView.vue?vue&type=template&id=32f52d1f&scoped=true"
import script from "./EnduserChatSettingView.vue?vue&type=script&lang=js"
export * from "./EnduserChatSettingView.vue?vue&type=script&lang=js"

import "./EnduserChatSettingView.vue?vue&type=style&index=0&id=32f52d1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f52d1f"]])

export default __exports__